class ProductTabs{constructor(){this.init()}init(){const t=document.querySelector(".product__info-wrapper");if(!t)return;const e=t.querySelector("product-info");if(!e)return;const c=Array.from(t.querySelectorAll(".product__accordion")),n=t.querySelector(".productlist-grid");0!==c.length&&this.createTabs(e,c,n)}createTabs(t,e,c){const n=document.createElement("div");n.className="product-tabs";const a=document.createElement("ul");a.className="product-tabs__nav";const o=document.createElement("div");o.className="product-tabs__content";[...e.map(((t,e)=>{const c=t.querySelector("details"),n=c?.querySelector("summary"),a=c?.querySelector(".accordion__content"),o=n?.textContent.trim()||`Tab ${e+1}`,r=document.createElement("div");return r.className="tab-content",a&&(r.innerHTML=a.innerHTML),{title:o,content:r,id:`tab-${e}`}})),...c?[{title:"Styled With",content:c,id:"tab-styled-with"}]:[]].forEach(((t,e)=>{const c=document.createElement("li");c.innerHTML=`\n                <button class="product-tabs__nav-button ${0===e?"active":""}" \n                    data-tab="${t.id}">\n                    ${t.title}\n                </button>\n            `,a.appendChild(c);const n=document.createElement("div");n.id=t.id,n.className="product-tabs__panel "+(0===e?"active":""),n.appendChild(t.content.cloneNode(!0)),o.appendChild(n)})),a.addEventListener("click",(t=>{const e=t.target.closest(".product-tabs__nav-button");e&&(a.querySelectorAll(".product-tabs__nav-button").forEach((t=>t.classList.remove("active"))),o.querySelectorAll(".product-tabs__panel").forEach((t=>t.classList.remove("active"))),e.classList.add("active"),document.getElementById(e.dataset.tab)?.classList.add("active"))})),n.appendChild(a),n.appendChild(o),t.appendChild(n),e.forEach((t=>t.remove())),c?.remove()}}document.addEventListener("DOMContentLoaded",(()=>{new ProductTabs}));

// Add this to your theme.js file or create a new JavaScript file and include it in theme.liquid

document.addEventListener('DOMContentLoaded', function() {
  // Function to fix slider counters
  function fixSliderCounters() {
    // Find all slider components on the page
    const sliders = document.querySelectorAll('slider-component');
    
    sliders.forEach(slider => {
      // Get the counter elements
      const totalCounter = slider.querySelector('.slider-counter--total');
      const slides = slider.querySelectorAll('.slider__slide');
      
      if (totalCounter && slides.length > 0) {
        // Set correct total count
        const correctTotal = slides.length;
        totalCounter.textContent = correctTotal.toString();
        
        // Create a MutationObserver to continuously monitor the counter
        const observer = new MutationObserver(function() {
          if (totalCounter.textContent !== correctTotal.toString()) {
            totalCounter.textContent = correctTotal.toString();
          }
        });
        
        // Observe changes to the counter text
        observer.observe(totalCounter, { 
          characterData: true, 
          childList: true, 
          subtree: true 
        });
        
        // Handle slider button clicks
        const prevNextButtons = slider.querySelectorAll('.slider-button');
        prevNextButtons.forEach(button => {
          button.addEventListener('click', function() {
            // Reset after button click with a slight delay
            setTimeout(function() {
              totalCounter.textContent = correctTotal.toString();
            }, 10);
          });
        });
      }
    });
  }
  
  // Run the fix initially
  fixSliderCounters();
  
  // Optionally, also run when the Shopify section:load event fires
  // This helps with dynamic sections that might be loaded after page load
  document.addEventListener('shopify:section:load', fixSliderCounters);
});